import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { createStructuredSelector } from 'reselect'
import find from 'lodash/find'
import get from 'lodash/get'
import set from 'lodash/set'
import sortBy from 'lodash/sortBy'
import isEmpty from 'lodash/isEmpty'
import axios from 'axios'
import moment from '../../lib/moment.js'
import styled from 'styled-components'
import shortid from 'shortid'
import {
  Container,
  Row,
  Col,
  Badge,
  Button,
  ButtonGroup,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  CustomInput,
} from 'reactstrap'
import Cropper from 'react-cropper'
import 'cropperjs/dist/cropper.css'
import withLayout from '../../helpers/withLayout'
import { BASE_URL, COLORS, FONTS } from '../../constants'
import noImage from '../../static/images/Not_available.jpg'
import {
  modalAction,
  lobAction,
  positionAction,
  authAction,
  leaveGenerationAction,
  employeeAction,
  consentAction,
  consentLogAction,
  companyAction,
} from './../../actions/'
import {
  modalSelector,
  lobSelector,
  positionSelector,
  authSelector,
  leaveGenerationSelector,
  employeeSelector,
  consentSelector,
  consentLogSelector,
  companySelector,
} from './../../selectors'
import CustomModalMessage from '../../components/modal-message'
import CustomModal from '../../components/modal'
import { ProfileImageModal } from '../../components/modal/profile-image-modal'
import LeaveChartEntitlement from '../../components/home-chart'
import * as CONSTANTS from '../../components/employee/constants'
import { generateButton } from '../../components/employee/helpers/button'

class Home extends React.Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    const tempState = prevState
    if (get(nextProps, 'getLeaveGenerationData')) {
      set(tempState, 'leaveGenerations', get(nextProps, 'getLeaveGenerationData.leaveGenerations'))
      set(tempState, 'prettyLeaveGeneration', get(nextProps, 'getLeaveGenerationData.prettyLeaveGeneration'))
      nextProps.resetGetLeavegeneration()
    }
    if (get(nextProps, 'authData.user')) {
      if (isEmpty(tempState.user)) {
        set(tempState, 'user', get(nextProps, 'authData.user'))
      }
    }
    if (get(nextProps, 'employeeEditProfile.employeeEditProfile')) {
      nextProps.showConfirm('editProfile', get(nextProps, 'employeeEditProfile.status') === 200 ? 200 : 'Error', get(nextProps, 'employeeEditProfile.message'))
      nextProps.resetEditProfile()
    }
    return tempState
  }
  constructor(props) {
    super(props)
    this.state = {
      leaveGenerations: [],
      prettyLeaveGeneration: [],
      user: {},
      uploadModal: false,
      isEdit: false,
      showConsent: true,
    }
    //this.activeConsent = this.activeConsent.bind(this)
   
  }
  

  componentDidMount() {
    const maintenanceMsg = process.env.REACT_APP_MAINTENANCE_MESSAGE
    if (maintenanceMsg && maintenanceMsg !== '') this.props.showModal('alert', '', maintenanceMsg)
    const access_token = localStorage.getItem('access_token')
    const user_id = localStorage.getItem('_id')
    this.props.getAuth(localStorage.getItem('access_token'))
    this.props.lobList(localStorage.getItem('access_token'))
    this.props.positionList(localStorage.getItem('access_token'))
    this.props.consentList(localStorage.getItem('access_token'))
    this.props.getLeaveGeneration(user_id, access_token)
    this.props.consentLogGet(user_id, localStorage.getItem('access_token'))
    this.props.companyList(localStorage.getItem('access_token'))
  }
  uploadPhoto = (e) => {
    e.preventDefault()
    let files
    if (e.dataTransfer) {
      files = e.dataTransfer.files
    } else if (e.target) {
      files = e.target.files
    }
    const reader = new FileReader()
    reader.onload = () => {
      this.setState({
        uploadModal: true,
        src: reader.result,
      })
    }
    reader.readAsDataURL(files[0])
  }

  closeUploadModal = () => {
    this.setState({ uploadModal: false })
  }
  closeConsentModal = () => {
    this.setState({ showConsent: false })
  }

  cropImage = () => {
    const self = this
    if (typeof this.cropper.getCroppedCanvas() === 'undefined') {
      return
    }
    this.cropper.getCroppedCanvas().toBlob((blob) => {
      const data = new FormData()

      data.set('user_id', localStorage.getItem('_id'))

      const image = new Image()
      image.onload = function () {
        // Resize image
        const canvas = document.createElement('canvas')
        canvas.width = 600
        canvas.height = 600
        canvas.getContext('2d').drawImage(image, 0, 0, 600, 600)

        canvas.toBlob((innerBlob) => {
          data.set('image', innerBlob)

          canvas.width = 128
          canvas.height = 128
          canvas.getContext('2d').drawImage(image, 0, 0, 128, 128)
          canvas.toBlob((innerBlob2) => {
            data.set('image_thumbnail', innerBlob2)

            axios({
              method: 'post',
              url: `${BASE_URL}/upload/user-profile-image`,
              headers: {
                'authorization': `bearer ${localStorage.getItem('access_token')}`,
              },
              data,
            }).then((resp) => {
              if (resp.status === 200) {
                self.props.showConfirm('confirmUpload', 'Uploaded Successfully', 'Your image had been uploaded.')
                self.props.getAuth(localStorage.getItem('access_token'))
                self.closeUploadModal()
              }
            })
          })
        })
      }
      image.src = this.cropper.getCroppedCanvas().toDataURL('image/jpeg')
    })
  }

  rotateImage = (degree) => {
    if (typeof this.cropper === 'undefined') return
    this.cropper.rotate(degree)
  }

  handleEdit = (e) => {
    if (this.state.isEdit) {
      this.editEmployee()
    }
    this.setState({ isEdit: !this.state.isEdit })
  }

  editEmployee = () => {
    const user = this.state.user
    const payload = {
      number_of_children: user.number_of_children,
      phone: user.phone,
      personal_email: user.personal_email,
      address: user.address,
      marital_status: user.marital_status,
      emergency_contact_name: user.emergency_contact_name,
      emergency_relationship: user.emergency_relationship,
      emergency_phone_number: user.emergency_phone_number,
    }
    const access_token = localStorage.getItem('access_token')
    const user_id = localStorage.getItem('_id')
    this.props.editProfile(user_id, payload, access_token)
  }

  handleChange = (e) => {
    this.setState({ user: { ...this.state.user, [e.target.name]: e.target.value } })
  }

  selectButton = (confirmStatus, confirmType) => {
    if (confirmStatus === 200) return generateButton('success', () => this.props.hideConfirm(confirmType))
    else if (confirmStatus === 'Error') return generateButton('error', () => this.props.hideConfirm(confirmType))
    return null
  }
  renderModal(code) {
    const { consentData, authData, companyData } = this.props
    const consentDes = get(find(consentData,{ _id: code, status: 'true' }), 'description', '')
    const title = get(authData.user, 'title', '')
    const firstName = get(authData.user, 'first_name', '-')
    const lastName = get(authData.user, 'last_name', '')
    const employeeCodeString = get(authData.user, 'emp_code', '-')
    const company_id = get(authData.user, 'company_id', '')
    const company_name = get(find(companyData, {
      _id: company_id }), 'name', '')
      const style_bold = '<style>strong {font-weight: bold;}</style>'
      const description = style_bold + consentDes.replace(/{User_Title}/g, title)
      .replace(/{User_FirstName}/g, firstName)
      .replace(/{User_LastName}/g, lastName)
      .replace(/{User_ID}/g, employeeCodeString)
      .replace(/{User_Company}/g, company_name)
    return (
      <div dangerouslySetInnerHTML={ { __html: description } } />
    )
  }
  activeConsent(code) {
    const { consentLogData } = this.props
    // const consentId = get(find(consentData,{ _id: code, status: 'true' }), '_id', '')
    const consent = get(find(consentLogData, {
      document_code: code,
    }), '_id')
    this.props.activeConsent(consent, localStorage.getItem('access_token'))
    this.props.showConfirm('confirmUpload', 'Employment Consent Statement', 'Accepted.')
    this.setState({ showConsent: false })
  }
  render() {
    const isAuthenticated = get(this.props, 'redirectAuth.isAuthenticated')
    const redirect = get(this.props, 'redirectAuth.redirect')
    if (redirect) {
      localStorage.clear()
      if (isAuthenticated) localStorage.setItem('bad_token', true)
      this.props.resetAuth()
      window.location = '/'
    }

    const confirmType = get(this.props, 'confirmType')
    const confirmStatus = get(this.props, 'confirmStatus')
    const confirmMessage = get(this.props, 'confirmMessage')

    const { lobData, positionData, authData, consentData, consentLogData } = this.props
    if (lobData === undefined || positionData === undefined || authData === undefined) {
      return <div />
    }
    const lobId = get(authData, 'user.lob_id', '')// currentUser.lob_id
    const positionId = get(authData, 'user.position_id', '')// currentUser.position_id
    let lob
    let position
    let yearOfServiceString

    if (lobData) {
      lob = find(lobData, {
        _id: lobId,
      })
    }
    if (positionData) {
      position = find(positionData, {
        _id: positionId,
      })
    }

    const title = get(authData.user, 'title', '')
    const firstName = get(authData.user, 'first_name', '-')
    const lastName = get(authData.user, 'last_name', '')
    const supervisorTitle = get(authData.supervisor, 'title', '')
    const supervisorFirstName = get(authData.supervisor, 'first_name', '-')
    const supervisorLastName = get(authData.supervisor, 'last_name', '')
    const userNameString = `${title} ${firstName} ${lastName}`
    const lobNameString = get(lob, 'name', '-')
    const positionNameString = get(position, 'name', '-')
    const employeeCodeString = get(authData.user, 'emp_code', '-')
    const supervisorString = `${supervisorTitle} ${supervisorFirstName} ${supervisorLastName}`
    const hiringDate = get(authData.user, 'hiring_date', '-') || ''
    const hiringDateString = get(authData.user, 'hiring_date', '-') ? moment(get(authData.user, 'hiring_date', '')).format('DD/MM/YYYY') : ''
    // const consentHeader = get(find(consentData, {
    //   status: 'true',
    // }), 'header')
    const consentHeader = 'Employment Consent Statement'
    let log = ''
    let code = ''
    const doclist = sortBy(consentData, 'updated').reverse()
    if (consentLogData) {
      for (const element of doclist) {
          if(get(element, 'status', '') === 'true'){
            log = find(consentLogData, { document_code : get(element, '_id', '')})
            if(log !== undefined){
              code = get(log, 'document_code')
              break
            }
          }
      }
      // log = find(consentLogData, {
      //   document_code: get(find(sortBy(consentData, 'updated').reverse(), {
      //     status: 'true',
      //   }), '_id'),
      // })

    }

    const status = get(log, 'status', '')

    if (hiringDate) {
      try {
        const year = moment().diff(moment(hiringDate), 'years')
        const month = moment().diff(moment(hiringDate), 'months') - (year * 12)
        yearOfServiceString = `${year} years ${month} month`
      } catch (e) {
        yearOfServiceString = ''
      }
    }
    const closeBtn = <button className="close" onClick={ this.closeConsentModal }>&times;</button>;
    const buttonOK = <NewButton color="info" onClick={ () => this.props.hideConfirm('confirmUpload') }>OK</NewButton>
    return (
      <DataCon fluid >
        <CustomModal
          hide={ () => this.props.hideModal('alert') }
          show={ get(this.props, 'modalType') === 'alert' }
          type={ get(this.props, 'modalStatus') }
          message={ get(this.props, 'modalMessage') }
          fontColor='black'
        />
        { get(this.props, 'confirmType') === 'confirmUpload' &&
          <CustomModalMessage
            hide={ () => this.props.hideConfirm('confirmUpload') }
            show={ get(this.props, 'confirmType') === 'confirmUpload' }
            type={ get(this.props, 'confirmStatus') }
            message={ get(this.props, 'confirmMessage') }
            button={ buttonOK }
          />
        }
        <CustomModalMessage
          hide={ () => this.props.hideConfirm(confirmType) }
          show={ confirmType === 'editProfile' }
          type={ confirmStatus }
          message={ confirmMessage }
          button={ this.selectButton(confirmStatus, confirmType) }
        />
        { get(this.props, 'confirmType') === 'showImgProfile' &&
          <ProfileImageModal
            isOpen={ get(this.props, 'confirmType') === 'showImgProfile' }
            handleClose={ () => this.props.hideConfirm('showImgProfile') }
            src={ get(authData, 'user.image_url') }
          />
        }
        <DataRow className="row no-gutters" >
          <ColProfile md={ 4 }>
            <DivButton>
              <BadgeUserImg
                onClick={ () => this.props.showConfirm('showImgProfile', 'User Image', 'Your image had been uploaded.') }
              >
                <UserImage src={ get(authData, 'user.image_url') !== '' && get(authData, 'user.image_url') !== undefined ? get(authData, 'user.image_url') : noImage } />
              </BadgeUserImg>
              <br />
            </DivButton>
            <DivButton>
              <UploadText>Upload new photo
                <InputPhoto id='fileUpload' type="file" onChange={ this.uploadPhoto } />
              </UploadText>
            </DivButton>
            <DataDiv>
              <TypeText>Name</TypeText>
              <DataText>{ userNameString }</DataText>
              <TypeText>Employee ID</TypeText>
              <DataText>{ employeeCodeString }</DataText>
              <TypeText>LOB</TypeText>
              <DataText>{ lobNameString }</DataText>
              <TypeText>Position</TypeText>
              <DataText>{ positionNameString }</DataText>
              <TypeText>Supervisor</TypeText>
              <DataText>{ supervisorString }</DataText>
              <TypeText>Hiring Date</TypeText>
              <DataText>{ hiringDateString }</DataText>
              <TypeText>Year of Services</TypeText>
              <DataText>{ yearOfServiceString }</DataText>
            </DataDiv>
          </ColProfile>
          <ColDataChart>
            <RowConChart>
              { get(this, `state.prettyLeaveGeneration.${moment().year()}`, [])
                .map(leaveGeneration => {
                  if (get(leaveGeneration, 'leave_entitlement_code') === 'E001'
                  || get(leaveGeneration, 'leave_entitlement_code') === 'E002'
                  || get(leaveGeneration, 'leave_entitlement_code') === 'E003'
                  || get(leaveGeneration, 'leave_entitlement_code') === 'E004') {
                    return (
                      <ColCard xs="6" key={ `${get(leaveGeneration, 'name')}-${moment().year()}` }>
                        <LeaveChartEntitlement
                          header={ get(leaveGeneration, 'name') }
                          Remain={ get(leaveGeneration, 'meta.remaining') }
                          Pending={ get(leaveGeneration, 'meta.pending') }
                          Used={ get(leaveGeneration, 'meta.approved') }
                          Total={ get(leaveGeneration, 'meta.total') }
                        />
                      </ColCard>
                    )
                  }
                  return null
                }) }
            </RowConChart>
          </ColDataChart>
          <ColDataChartRes>
            <RowConChartRes>
              { get(this, `state.prettyLeaveGeneration.${moment().year()}`, [])
                .map(leaveGeneration => {
                  if (get(leaveGeneration, 'leave_entitlement_code') === 'E001'
                  || get(leaveGeneration, 'leave_entitlement_code') === 'E002'
                  || get(leaveGeneration, 'leave_entitlement_code') === 'E003'
                  || get(leaveGeneration, 'leave_entitlement_code') === 'E004') {
                    return (
                      <ColCard xs="12" key={ `${get(leaveGeneration, 'name')}-${moment().year()}` }>
                        <LeaveChartEntitlement
                          header={ get(leaveGeneration, 'name') }
                          Remain={ get(leaveGeneration, 'meta.remaining') }
                          Pending={ get(leaveGeneration, 'meta.pending') }
                          Used={ get(leaveGeneration, 'meta.approved') }
                          Total={ get(leaveGeneration, 'meta.total') }
                        />
                      </ColCard>
                    )
                  }
                  return null
                }) }
            </RowConChartRes>
          </ColDataChartRes>
        </DataRow>
        <Modal isOpen={ this.state.showConsent === true && status === 'PENDING'} size='lg'>
          <ModalHeader close={ closeBtn }>{consentHeader} </ModalHeader>
          <ModalBody style={ { 'max-height': 'calc(100vh - 210px)', 'overflow-y': 'auto', 'b, strong': 'font-weight: bold !important' } }>
            <div>{this.renderModal(code)}</div>
            <center><Button color="success" onClick={ () => this.activeConsent(code) }>By accepting the above terms, I hereby acknowledge and give my consent to the processing of my personal data by the Company.</Button>
              <Button color="link" target="_blank" href={ 'https://itsa.iamconsulting.co.th/PRD/ManualDoc/HR%20Data%20Privacy%20Policy.pdf' }>For more information check out our HR Data Privacy Policy</Button></center>
          </ModalBody>

        </Modal>
        <Modal isOpen={ this.state.uploadModal }>
          <ModalHeader>Crop Image</ModalHeader>
          <ModalBody>
            <Cropper
              style={ { height: 400, width: '100%' } }
              preview=".img-preview"
              guides={ false }
              aspectRatio={ 1 }
              src={ this.state.src }
              ref={ cropper => { this.cropper = cropper } }
              setDragMode={ 'crop' }
              movable={ false }
              center={ true }
            />
          </ModalBody>
          <ModalFooter>
            <ButtonGroup>
              <Button color="primary" onClick={ () => this.rotateImage(90) }>Rotate 90</Button>
              <Button color="primary" onClick={ () => this.rotateImage(-90) }>Rotate -90</Button>
            </ButtonGroup>
            <Button color="primary" onClick={ this.cropImage }>Crop</Button>{' '}
            <Button color="secondary" onClick={ this.closeUploadModal }>Cancel</Button>
          </ModalFooter>
        </Modal>
        <DataRow className="row no-gutters" >
          <ColProfile md={ 4 }>
            <InfoDiv>
              <Label>Personal Information</Label>
              <TypeText>Phone Number</TypeText>
              <InputFieldNumber
                name="phone"
                type="number"
                pattern="[0-9]*"
                inputMode="numeric"
                placeholder="Enter Phone Number"
                disabled={ !get(this.state, 'isEdit') }
                value={ get(this.state, 'user.phone', '') }
                onChange={ this.handleChange }
              />
              <TypeText>Personal Email</TypeText>
              <InputField
                name="personal_email"
                placeholder="Enter Personal Email"
                disabled={ !get(this.state, 'isEdit') }
                value={ get(this.state, 'user.personal_email', '') }
                onChange={ this.handleChange }
              />
              <TypeText>Address</TypeText>
              <InputField
                name="address"
                placeholder="Enter Address"
                disabled={ !get(this.state, 'isEdit') }
                value={ get(this.state, 'user.address', '') }
                onChange={ this.handleChange }
              />
              <TypeText>Marital Status</TypeText>
              <CustomInputField
                type="select"
                id="marital_status"
                name="marital_status"
                placeholder="Enter Marital Status"
                disabled={ !get(this.state, 'isEdit') }
                value={ get(this.state, 'user.marital_status', '') }
                onChange={ this.handleChange }
              >
                {CONSTANTS.marital_status.map((s) => (
                  <option key={ shortid() } value={ s.value }>{ s.label }</option>
                ))}
              </CustomInputField>
              <TypeText>Number of Children</TypeText>
              <InputFieldNumber
                type="number"
                pattern="[0-9]*"
                inputMode="numeric"
                name="number_of_children"
                placeholder="Enter Number of Children"
                disabled={ !get(this.state, 'isEdit') }
                value={ get(this.state, 'user.number_of_children', '') }
                onChange={ this.handleChange }
              />
              <hr style={ { marginTop: '1.4rem' } } />
              <Label>Emergency Contact</Label>
              <TypeText>Emergency Contact Full Name</TypeText>
              <InputField
                name="emergency_contact_name"
                placeholder="Enter Emergency Contact"
                disabled={ !get(this.state, 'isEdit') }
                value={ get(this.state, 'user.emergency_contact_name', '') }
                onChange={ this.handleChange }
              />
              <TypeText>Emergency Contact Relationship</TypeText>
              <InputField
                name="emergency_relationship"
                placeholder="Enter Relationship"
                disabled={ !get(this.state, 'isEdit') }
                value={ get(this.state, 'user.emergency_relationship', '') }
                onChange={ this.handleChange }
              />
              <TypeText>Emergency Contact Phone Number</TypeText>
              <InputFieldNumber
                type="number"
                pattern="[0-9]*"
                inputMode="numeric"
                name="emergency_phone_number"
                placeholder="Enter Phone Number"
                disabled={ !get(this.state, 'isEdit') }
                value={ get(this.state, 'user.emergency_phone_number', '') }
                onChange={ this.handleChange }
              />
            </InfoDiv>
            <CustomButton
              color='success'
              border={ COLORS.UPLOAD_COLOR_BORDER }
              onClick={ this.handleEdit }
            >
              { this.state.isEdit ? 'Save' : 'Edit'}
            </CustomButton>
          </ColProfile>
        </DataRow>
      </DataCon>
    )
  }
}

Home.propTypes = {
  lobData: PropTypes.array,
  authData: PropTypes.object,
  lobList: PropTypes.func.isRequired,
  positionList: PropTypes.func.isRequired,
  positionData: PropTypes.array,
  showModal: PropTypes.func.isRequired,
  hideModal: PropTypes.func.isRequired,
  showConfirm: PropTypes.func.isRequired,
  hideConfirm: PropTypes.func.isRequired,
  getAuth: PropTypes.func.isRequired,
  resetAuth: PropTypes.func.isRequired,
  getLeaveGeneration: PropTypes.func.isRequired,
  editProfile: PropTypes.func.isRequired,
  consentData: PropTypes.array,
  consentList:  PropTypes.func.isRequired,
  consentLogData: PropTypes.array,
  activeConsent: PropTypes.func.isRequired,
  companyData: PropTypes.array,
  companyList: PropTypes.func.isRequired,
}
Home.defaultProps = {
  lobData: [],
  positionData: [],
  authData: {},
  consentData: [],
  consentLogData: [],
}

const mapStateToProps = (state, props) => createStructuredSelector({
  confirmStatus: modalSelector.confirmStatus,
  confirmType: modalSelector.confirmType,
  confirmMessage: modalSelector.confirmMessage,
  modalStatus: modalSelector.modalStatus,
  modalType: modalSelector.modalType,
  modalMessage: modalSelector.modalMessage,
  lobData: lobSelector.getListLOB,
  positionData: positionSelector.getListPosition,
  redirectAuth: authSelector.redirectAuth,
  authData: authSelector.getAuth,
  employeeEditProfile: employeeSelector.getEditUserProfile,
  getLeaveGenerationData: leaveGenerationSelector.getLeaveGenerationData,
  consentData: consentSelector.getListConsent,
  consentLogData: consentLogSelector.getConsentLog,
  companyData: companySelector.getListCompany,
})(state, props)
const mapDispatchToProps = dispatch => bindActionCreators({
  showConfirm: modalAction.showConfirm,
  hideConfirm: modalAction.hideConfirm,
  showModal: modalAction.showModal,
  hideModal: modalAction.hideModal,
  lobList: lobAction.getLOB,
  positionList: positionAction.getPosition,
  getAuth: authAction.auth,
  editProfile: authAction.editProfile,
  resetAuth: authAction.resetAuthUser,
  getLeaveGeneration: leaveGenerationAction.getLeaveGeneration,
  resetGetLeavegeneration: leaveGenerationAction.resetGetLeaveGeneration,
  resetEditProfile: employeeAction.resetEditProfileUser,
  consentList: consentAction.getConsentList,
  consentLogGet: consentLogAction.getConsentLogByEmpCode,
  activeConsent: consentLogAction.activateConsentLog,
  companyList: companyAction.getCompany
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(withLayout(Home))

const InputPhoto = styled.input`
  position: absolute;
  top: 0;
  right: 0;
  min-width: 100%;
  min-height: 100%;
  font-size: 100px;
  text-align: right;
  filter: alpha(opacity=0);
  opacity: 0;
  outline: none;
  cursor: inherit;
  display: block;
`
const ColCard = styled(Col)`
  padding-right: 5px ;
  padding-left: 5px ;
  padding-bottom: 5px;
  padding-top: 0px ;
  margin-bottom: 5px;
  width: 45%;
  position: relative;
  @media (max-width: 575.98px) {
    width: 100% ;
    padding-right: 0px ;
  }
  @media (max-width: 767.98px) {
    width: 100% ;
    padding-right: 0px ;
  }
  @media (max-width: 991.98px) {
    width: 100% ;
    padding-right: 0px ;
  }
`
const ColDataChart = styled(Col)`
  padding-right: 10% ;
  padding-left: 10% ;
  overflow: auto;
  @media (max-width: 575.98px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait)  {
    display:none;
  }
  @media (max-width: 575.98px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape)  {
    display:none;
  }
  @media (max-width: 767.98px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape) {
    display:none;
  }
  @media (max-width: 767.98px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait) {
    overflow: auto;
    margin-right: 1%;
  }
  @media (max-width: 991.98px) and (-webkit-min-device-pixel-ratio: 2)  {
    overflow: auto;
    margin-right: 1%;
  }
`
const ColDataChartRes = styled(Col)`
  padding-right: 10% ;
  padding-left: 10% ;
  margin-right: 2%;
  @media (min-width: 992px) {
      display:none;
    }
  @media (min-width: 768px) {
    overflow: auto;
    display:none;
  }
  @media (min-width: 1200px) {
    display:none;
  }
`
const TypeText = styled.p`
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  font-size: ${FONTS.SMALL_SIZE};
  color: ${COLORS.BLACK};
  margin: 5px 0px 5px 0px;
`
const Label = styled.p`
  font-family: 'Gotham-Bold' !important;
  font-size: 14px ;
  color: ${COLORS.BLACK};
`

const CustomButton = styled(Button)`
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.SMALL_SIZE};
  background-color: ${props => { return props.bg }};
  width: 100px;
  height: 30px;
  margin-right: 10px;
  margin-top: auto;
  margin-bottom: 10px;
  color: white;
  border-color: ${props => { return props.border }};
  border-radius: 4px;
  position: relative;
  cursor: pointer;
  &:hover {
    background-color: #333333;
    color: #ffffff;
    border-color: #CCCCCC;
  };
  right: 0;
  align-self: flex-end;
`

const DataText = styled.p`
  font-family: ${FONTS.GOTHAM} !important;
  font-size: ${FONTS.SMALL_SIZE};
  color: ${COLORS.BLACK};
  margin: 0;
  margin-bottom: 5px;
`
const DivButton = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`
const UploadText = styled(Button)`
  cursor: pointer;
  position: relative;
  overflow: hidden;
  margin-top: 1%;
  margin-bottom: 1%;
  font-family: ${FONTS.GOTHAM_BOLD};
  font-size: ${FONTS.SMALL_SIZE};
  color: ${COLORS.UPLOAD_COLOR};
  text-decoration: underline;
  background-color: transparent;
  border:none;
  &:hover{
    background-color: transparent;
    color: ${COLORS.UPLOAD_COLOR};
    text-decoration: underline;
  }
`
const ColProfile = styled(Col)`
  font-family: 'Gotham-Bold' !important;
  font-weight: lighter;
  font-size: 14px ;
  max-height: 100%;
  overflow-y: auto;
  color: #428BCA;
  background-color: #FFFFFF ;
  -moz-box-shadow: 1px 2px 4px rgba(0, 0, 0,0.16);
  -webkit-box-shadow: 1px 2px 4px rgba(0, 0, 0, .16);
  box-shadow: 1px 2px 4px rgba(0, 0, 0, .16);
  position:relative;
  margin-right:1%;
  @media (max-width: 575.98px) {
    margin-bottom:1%;
  }
  @media (max-width: 767.98px) {
    margin-bottom:1%;
  }
  @media (max-width: 991.98px) {
    margin-bottom:1%;
  }
  display: flex;
  flex-direction: column;
`
const UserImage = styled.img`
  width : 100% ;
  height : 100% ;
  border-radius: 50%;
`
const BadgeUserImg = styled(Badge)`
  width : 180px ;
  height : 180px;
  margin-bottom: 1%;
  margin-top: 8%;
  background-color: transparent ;
  border-radius: 50%;
  border: 1px solid #ccc;
  cursor: pointer;
`
const DataDiv = styled.div`
  padding-left: 10%;
  padding-bottom: 20px;
  background-color:#FFFFFF;
`
const InfoDiv = styled.div`
  padding-top: 20px;
  padding-left: 10%;
  padding-right: 10%;
  padding-bottom: 20px;
  background-color:#FFFFFF;
`
const InputField = styled(Input)`
  font-family: 'Gotham' !important;
  width : 100% ;
  font-size: 12px ;
`
const InputFieldNumber = styled(Input)`
  font-family: 'Gotham' !important;
  width : 100% ;
  font-size: 12px ;
  ::-webkit-inner-spin-button,
  ::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`
const CustomInputField = styled(CustomInput)`
  font-family: 'Gotham' !important;
  width : 100% ;
  font-size: 12px ;
`
const DataCon = styled(Container)`
  max-height: 100% ;
  width: 100%;
  padding: 10px;
  overflow-y: scroll;
`
const DataRow = styled(Row)`
  @media (max-width: 575.98px) {
    width: 100% ;
  }
  @media (max-width: 767.98px) {
    width: 100% ;
  }
  @media (max-width: 991.98px) {
    width: 100% ;
  }
  height: 100% ;
  width: 100% ;
  padding: 0%;
  margin-bottom: 20px;
`
const NewButton = styled(Button)`
  width: 100px;
  height:50px;
  margin: 10px;
`
const RowConChart = styled(Row)`
  overflow-y: hidden ;
  max-height: calc(100vh - 100px);
  @media (max-width: 767.98px) {
  overflow-y: auto;
  }
  @media (max-width: 991.98px) and (-webkit-min-device-pixel-ratio: 2){
    overflow-y: auto ;
  }
`
const RowConChartRes = styled(Row)`
  padding-left : 3%;
  padding-right : 3%;
  padding-bottom : 35%;
  overflow-y: hidden;
  max-height: calc(100vh + 200px);;
  overflow: auto;
`



// WEBPACK FOOTER //
// ./src/pages/home/index.js